import { PersonAdd, PersonOutline } from '@material-ui/icons'
import ErrorLine from 'components/ErrorLine'
import TimerProgress from 'components/mint/TimerProgress'
import { fetchRooms } from 'controllers/AssetController'
import { updateSubscribed } from 'controllers/CoreServiceController'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSubscribedStudios } from 'redux/actions/accountActions'
import { logWithTime } from 'util/screenUtils'
import { displayError } from 'util/screenUtils'

export default function SubscribeStudio({ username, handle }) {
    const { subscribedStudios } = useSelector(state => state.account)
    const [homeStudio, setHomeStudio] = useState()
    const [error, setError] = useState()
    const [updating, setUpdating] = useState(false)
    const dispatch = useDispatch()

    const getOwnerRooms = async () => {
        try {
            const ownerRooms = await fetchRooms(username, false)
            console.log(`SubscribeStudio got rooms for ${username}`, ownerRooms)
            const homeStudio = ownerRooms.find(st => st.room.name === 'home')
            setHomeStudio(homeStudio)
        } catch (error) {
            displayError(error, setError)
        }

    }

    const displaySubscribed = () => {
        if (homeStudio) {
            const { _id } = homeStudio.room
            let subscribed
            if (subscribedStudios && subscribedStudios.length) {
                subscribed = subscribedStudios.findIndex(r => r.roomId === _id) !== -1
            }
            const message = `Click to ${subscribed ? 'unsubscribe from' : 'subscribe to'} @${handle}`
            return (
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    {updating ? <TimerProgress /> :
                        <div
                            onClick={() => subscribeRoom(!subscribed)}
                            title={message}
                        >
                            {subscribed ? <PersonOutline style={{
                                height: '30px',
                                width: '30px'
                            }} /> :
                                <PersonAdd
                                    style={{
                                        height: '30px',
                                        width: '30px'
                                    }}
                                />}
                        </div>}
                    <ErrorLine error={error} />
                    {message}
                </div>
            )
        }
    }

    const subscribeRoom = async (subscribe) => {
        const { _id } = homeStudio.room
        try {
            setUpdating(true)
            const updatedUser = await updateSubscribed(_id, subscribe ? 1 : 0)
            logWithTime('subscribeRoom Received updated user', updatedUser)
            const { subscribedRooms } = updatedUser
            dispatch(setSubscribedStudios(subscribedRooms))
        } catch (error) {
            displayError(error, setError, 4)
        }
        setUpdating(false)

    }

    useEffect(() => {
        getOwnerRooms()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [username])
    return displaySubscribed()
}